<template>
  <div class="tree-node" v-if="shouldShow">
    <div
      class="tree-node-item"
      :class="{
        selected: isSelected,
        highlight: isMatch,
      }"
      @click="handleSelect"
    >
      <div :style="indentStyle"></div>

      <div class="checkbox-container">
        <div class="custom-checkbox" :class="{ checked: isSelected }"></div>
      </div>

      <div class="node-content">
        <span
          class="expand-icon"
          :class="{ expanded: isExpanded }"
          v-if="hasChildren"
          @click.stop="handleToggle"
        >
          ▶
        </span>
        <span
          class="node-label"
          v-html="renderHighlightedText(node.label)"
        ></span>
      </div>
    </div>

    <div v-if="hasChildren && isExpanded">
      <StepNode
        v-for="child in node.children"
        :key="child.value"
        :node="child"
        :level="level + 1"
        :selected-value="selectedValue"
        :expanded-nodes="expandedNodes"
        :search-keyword="searchKeyword"
        @select="$emit('select', $event)"
        @toggle="$emit('toggle', $event)"
      >
      </StepNode>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StepNode',
  props: {
    node: {
      type: Object,
      required: true,
    },
    level: {
      type: Number,
      default: 0,
    },
    selectedValue: {
      type: [String, Number],
      default: null,
    },
    expandedNodes: {
      type: Array,
      default: () => [],
    },
    searchKeyword: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      localExpanded: false,
    }
  },
  computed: {
    isSelected() {
      return this.selectedValue === this.node.value
    },

    isExpanded() {
      return this.expandedNodes.includes(this.node.value) || this.localExpanded
    },

    hasChildren() {
      return this.node.children && this.node.children.length > 0
    },

    isMatch() {
      return (
        this.searchKeyword &&
        this.node.label.toLowerCase().includes(this.searchKeyword.toLowerCase())
      )
    },

    shouldShow() {
      if (!this.searchKeyword) return true
      return this.isMatch || this.hasMatchingChildren(this.node)
    },

    indentStyle() {
      return {
        width: `${this.level * 20}px`,
        flexShrink: '0',
      }
    },
  },
  methods: {
    handleSelect() {
      this.$emit('select', this.node)
    },

    handleToggle() {
      if (this.hasChildren) {
        this.$emit('toggle', this.node)
      }
    },

    hasMatchingChildren(node) {
      if (!node.children) return false

      for (const child of node.children) {
        if (
          child.label
            .toLowerCase()
            .includes(this.searchKeyword.toLowerCase()) ||
          this.hasMatchingChildren(child)
        ) {
          return true
        }
      }

      return false
    },

    renderHighlightedText(text) {
      if (!this.searchKeyword) return text

      const lowerText = text.toLowerCase()
      const lowerKeyword = this.searchKeyword.toLowerCase()
      const keywordIndex = lowerText.indexOf(lowerKeyword)

      if (keywordIndex >= 0) {
        const before = text.substring(0, keywordIndex)
        const match = text.substring(
          keywordIndex,
          keywordIndex + this.searchKeyword.length,
        )
        const after = text.substring(keywordIndex + this.searchKeyword.length)

        return (
          before + '<span class="highlight-text">' + match + '</span>' + after
        )
      }

      return text
    },
  },
}
</script>